import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {formValueSelector, change} from "redux-form/immutable";
import Form from "./ChangeWarehouseForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelChangeWarehouseForOrder} from "../../actions/ShippingApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "warehouseId");
  errors = validatePresence(errors, values, "reason");
  return errors.toJS();
}

class ChangeWarehouseForOrderFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId,
      warehouseId: values.get("warehouseId"),
      reason: values.get("reason")
    }
    return this.props.changeWarehouseForOrder(updatedValues)
      .then((response) => {
        if (response.data.changeWarehouseForOrder.errors.length <= 0) {
          this.props.cancelChangeWarehouseForOrder();
        } else {
          let errors = createValidationErrors(response.data.changeWarehouseForOrder.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelChangeWarehouseForOrder();
  }

  handleAutoSelect() {
    this.props.change("ChangeWarehouseForm", "warehouseId", this.props.data.recommendedWarehouseId.warehouseId);
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let recommended = data.recommendedWarehouseId.warehouseId;
    let showAsRecommended = this.props.selectedWarehouseId === recommended;
    let warehouses = fromJS(data.warehousesForShippingOrder).map((warehouse) => {
      return Map({
        id: warehouse.get("id"),
        label: `${warehouse.get("id")} (${warehouse.getIn(["info", "system"], "")})`
      })
    });
    return (
      <Form
        warehouses={warehouses}
        selectedWarehouseIsRecommended={showAsRecommended}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        onAutoSelect={this.handleAutoSelect.bind(this)}
        />
    )
  }

}

const WAREHOUSE_IDS_WITH_RECOMMENDATION = gql`
  query warehouseIdsWithRecommendation($orderId: ID!) {
    warehousesForShippingOrder(orderId: $orderId) {
      id
      info {
        system
      }
    }
    recommendedWarehouseId(orderId: $orderId) {
      warehouseId
    }
  }
`;

const CHANGE_WAREHOUSE_FOR_ORDER = gql`
  mutation changeWarehouseForOrder($data: ChangeWarehouseForOrderInput!) {
    changeWarehouseForOrder(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(WAREHOUSE_IDS_WITH_RECOMMENDATION, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        orderId: props.orderId
      }
    })
  }),
  graphql(CHANGE_WAREHOUSE_FOR_ORDER, {
    props: ({ mutate }) => ({
      changeWarehouseForOrder: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const ChangeWarehouseForOrderFormContainerWithData = withProductQuery(ChangeWarehouseForOrderFormContainer);

const selector = formValueSelector("ChangeWarehouseForm");
function mapStateToProps(state, ownProps) {
  return {
    selectedWarehouseId: selector(state, "warehouseId"),
  }
}

export default connect(mapStateToProps, {cancelChangeWarehouseForOrder, change})(ChangeWarehouseForOrderFormContainerWithData);